import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {environment} from '../../../environments/environment';
import {IncidentsService} from '../../services/incidents.service';
import {NgxSpinnerModule, NgxSpinnerService} from 'ngx-spinner';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DateConversionPipe} from '../../pipes/date-conversion.pipe';
import {TranslatePipe} from '@ngx-translate/core';
import {DmsPipe} from '../../pipes/dms.pipe';
import {PaginatedIncidentComponentBase} from '../../shared/paginated-incident.component';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-harsh-driving',
  imports: [
    DateConversionPipe,
    NgxSpinnerModule,
    TranslatePipe,
    DmsPipe
  ],
  templateUrl: './harsh-driving.component.html',
  styleUrl: './harsh-driving.component.scss'
})
export class HarshDrivingComponent extends PaginatedIncidentComponentBase<any, any> {
  host: string = environment.host;

  harshDrivingEvents;
  @Input() filter?: string;

  constructor(incidentService: IncidentsService,
              spinnerService: NgxSpinnerService,
              cdRef: ChangeDetectorRef,
              modalService: NgbModal) {
    super(incidentService, spinnerService, cdRef, modalService);
  }

  protected override get incidentPage(): any {
    return this.harshDrivingEvents;
  }

  protected override set incidentPage(value: any) {
    this.harshDrivingEvents = value;
  }

  protected override get filterValue(): string | undefined {
    return this.filter;
  }

  protected override fetchPage(licencePlate?: string, skip?: number, limit?: number): Observable<any> {
    return this.incidentService.getHarshDrivingIncidents(licencePlate, skip, limit);
  }

}
